import React from "react";
import useActiveUsers from "./hooks/use-active-users";
import RecentlyActive from "../widget/RecentlyActive";

function RecentlyActiveDataBuilder({ mode }) {
  const { isActiveUsersLoading, activeUsersData: users = [] } =
    useActiveUsers();

  return (
    <RecentlyActive loading={isActiveUsersLoading} users={users} mode={mode} />
  );
}

export default RecentlyActiveDataBuilder;
